import { alpha } from './alpha';
import { getContrastTextColor } from './get-contrast-text-color';

type LpPanelBgTextColors = {
  mainText: string;
  subtleText: string;
  divider: string;
};

const darkPanelTextColors: LpPanelBgTextColors = {
  mainText: '#212121',
  subtleText: alpha('#212121', 0.8),
  divider: alpha('#212121', 0.2),
};

const lightPanelTextColors: LpPanelBgTextColors = {
  mainText: '#FFFFFF',
  subtleText: alpha('#FFFFFF', 0.8),
  divider: alpha('#FFFFFF', 0.2),
};

export function getLpPanelBgTextColors(panelBackgroundColor: string) {
  try {
    const contrastColor = getContrastTextColor(panelBackgroundColor);
    return contrastColor === 'white'
      ? lightPanelTextColors
      : darkPanelTextColors;
  } catch {
    return darkPanelTextColors;
  }
}
